import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Formats an ISO string like 2025-09-16T21:57:53.8125733-06:00
// into "Sep 16, 2025 | 21:57" (24h) or similar Figma style.
export function formatDateTime(value?: string | null): string {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date.getTime())) return '';

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = months[date.getMonth()];
  const day = String(date.getDate());
  const year = String(date.getFullYear());
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${month} ${day}, ${year} | ${hours}:${minutes}`;
}

// Formats permission strings by replacing underscores with spaces
export function formatPermission(permission: string): string {
  return permission.replace(/_/g, ' ');
}

// Axios 403 helper
export function isAxiosForbidden(error: any): boolean {
  try {
    const status = error?.response?.status;
    return Number(status) === 403;
  } catch {
    return false;
  }
}